import { useEffect } from "react";
import { useRouter } from "next/router";
import { getMySubscription } from "pages/api-clients/subscriptions";
import { useOrg } from "./useOrg";

export function useSubscriptionCheck() {
  const router = useRouter();
  const orgId = useOrg().id;

  useEffect(() => {
    const checkSubscription = async () => {
      if (!orgId) {
        return;
      }
      try {
        const orgs = await getMySubscription();
        const currentOrg = orgs?.find((o) => o.id === orgId);
        const subscription = currentOrg?.subscription;
        console.log("subscription", subscription);
        // If subscription is expired/canceled, redirect to subscriptions page
        if (
          (subscription && subscription?.status === "expired") ||
          subscription?.status === "canceled" ||
          (subscription?.status === "trialing" &&
            new Date(subscription.trialEndDate!) < new Date())
        ) {
          console.log(
            "Subscription check failed, redirecting to subscriptions page"
          );
          // If not already on the subscriptions page, redirect there
          if (!router.pathname.includes("/settings/subscriptions")) {
            router.push(`/${orgId}/settings/subscriptions`);
          }
        }
      } catch (error) {
        console.error("Failed to check subscription status:", error);
      }
    };

    checkSubscription();
  }, [orgId, router]);
}
